const STORE_LOCATOR_TIMINGS = {
  openingTime: "",
  closingTime: ""
};

export { STORE_LOCATOR_TIMINGS };
